// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Migration_MigrarColaboradoresResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract de POST /migration/colaboradores/migrar-todas
 * (controllers/migration/colaboradores.php::migrar_todas).
 *
 * O fechamento de uma carga em LOTE: o run do lote, a contabilidade dos quatro
 * desfechos, o que o proprio Zoho nao conseguiu exportar, e o desfecho de cada
 * colaborador.
 *
 * ---------------------------------------------------------------------------
 * `run_id` E O RUN DO LOTE — nao o de um colaborador
 * ---------------------------------------------------------------------------
 * E nele que a linha do tempo inteira e escrita, e e ele que a tela acompanha
 * pelo polling de `run/{id}`. Cada colaborador continua abrindo o run DELE (e
 * `resultados[].run_id` traz esse), que e o que da o historico por pessoa. Os
 * dois numeros sao diferentes de proposito e nenhum substitui o outro.
 *
 * ---------------------------------------------------------------------------
 * `bloqueadas` NAO ENTRA EM `falhas` — a distincao ja custou uma correcao
 * ---------------------------------------------------------------------------
 * As quatro contagens vem de `MigrationTally`, compartilhado com a E1, e a
 * regra e dele: bloqueada e uma RECUSA do preflight (o registro nao passou nos
 * blockers e nada foi escrito), falha e uma carga que COMECOU e quebrou no
 * meio. Somar as duas faria a tela dizer "3 falhas" para uma execucao em que
 * nada falhou, e mandaria o operador procurar um erro que nao existe.
 * `migradas + skipped + bloqueadas + falhas == total` sempre.
 *
 * ---------------------------------------------------------------------------
 * `erros_zoho` — quem nunca chegou
 * ---------------------------------------------------------------------------
 * Colaboradores que o proprio Deluge nao conseguiu exportar. Eles NAO aparecem
 * em `resultados` (nunca chegaram na lista) e nao entram em `total`. Sem este
 * campo eles sumiriam em silencio, e a conferencia de contagens da fase 6
 * acusaria uma diferenca sem explicacao.
 */
import type { Migration_ColaboradorResultadoRow } from './Migration_ColaboradorResultadoRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Migration_MigrarColaboradoresResponseDados {
run_id: number
total: number
migradas: number
skipped: number
bloqueadas: number
falhas: number
erros_zoho: string[]
resultados: Migration_ColaboradorResultadoRow[]
}

export type Migration_MigrarColaboradoresResponse = ApiResponse<Migration_MigrarColaboradoresResponseDados>;

registerResponseContract('Migration_MigrarColaboradoresResponse', {
  run_id:     { type: 'number',  required: true },
  total:      { type: 'number',  required: true },
  migradas:   { type: 'number',  required: true },
  skipped:    { type: 'number',  required: true },
  bloqueadas: { type: 'number',  required: true },
  falhas:     { type: 'number',  required: true },
  erros_zoho: { type: 'array',   required: true },
  resultados: {
    type: 'array',
    required: true,
    items: {
      zoho_id:  { type: 'string',  required: false },
      nome:     { type: 'string',  required: false },
      email:    { type: 'string',  required: false },
      status:   { type: 'string',  required: false },
      run_id:   { type: 'number',  required: false },
      sub:      { type: 'string',  required: false },
      blockers: {
        type: 'array',
        required: false,
        items: {
          code:     { type: 'string',  required: false },
          message:  { type: 'string',  required: false },
          severity: { type: 'string',  required: false },
          entity:   { type: 'string',  required: false },
          zoho_id:  { type: 'string',  required: false },
          label:    { type: 'string',  required: false },
        },
      },
      erro:     { type: 'string',  required: false },
    },
  },
})
